import { TransactionNotifyService } from "./transaction.notify.service";
import { AssetTransaction } from "@models/transaction";

export abstract class AssetTransactionNotifyService<T extends AssetTransaction> extends TransactionNotifyService<T> {
	protected caseNew(transaction: T): string {
		if (transaction.getType() === "transfer" || transaction.getType() === "withdrawal") {
			return "send-successfull";
		}
		if (transaction.getTrade().getIsSwap()) {
			return "swap_successful";
		}
		return transaction.getType() + "_successful";
	}
}
